import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ObjectVat = ({isVat}) => {
    const { t } = useTranslation(['Objects']);
    return (<div className="d-inline-flex">
        {isVat
            ?(<Badge className="mx-1 badge text-bg-danger" style={{fontSize:8}}>{t('vat')}</Badge>)
            :(<></>)}
    </div>)
}

export default ObjectVat;